export default __webpack_public_path__ + "static/media/arvore.949d021b.png";